import React from 'react';
import { ScreenSelect } from 'components/ScreenSelect/ScreenSelect';
import { SystemStatusBtn } from 'components/SystemStatusBtn/SystemStatusBtn';
import { ParkSelect } from 'components/ParkSelect/ParkSelect';
import { Icon } from 'theme/icons/Icon';
import { MediaMatcher } from 'components/MediaMatcher/MediaMatcher';
import { HeaderMenu } from 'components/HeaderMenu/HeaderMenu';
import { Clock } from 'components/Clock/Clock';
import { ClockContainer, Container, Left, LogoContainer, Logo, Right } from './Header.styles';
import RWELogo from '../../../lib/assets/RWE.png';
import { LightningRiskChart } from 'routes/Operations/components/Weather/LightningRiskChart';
import { env } from 'common/config';
import { useRematchDispatch, useRematchSelector } from 'models/rematchStore';
import { useNavigate, useLocation } from 'react-router-dom';
import { constructNewPathname } from 'common/state.helper';
import { Logger } from 'common/logger';

export const HeaderView = () => {
    const dispatch = useRematchDispatch();
    const navigate = useNavigate();
    const { pathName } = useLocation();
    const {
        selectedPark,
        selectedScreen,
        isWebSocketEnabled,
        menuVisible,
        parkList,
        allowedScreens,
    } = useRematchSelector((state) => state.appData);
    const {
        isAdmin,
        user: { name, emailAddress },
    } = useRematchSelector((state) => state.account);

    const adminUrl = isAdmin ? env.IAM_UI_URL : null;
    const region = { name: 'United Kingdom', parks: parkList };
    const userDisplayName = name || emailAddress;

    const changeHandler = (key) => (value) => {
        if (key === 'park') {
            Logger.info(`Changing park to ${value}`);
            const availableScreens = allowedScreens[value.toLowerCase()];
            if (!availableScreens.includes(selectedScreen.toLowerCase())) {
                dispatch.appData.setSelectedScreen(availableScreens[0]);
            }
            navigate(constructNewPathname(value, selectedScreen, pathName));
        }
        if (key === 'screen') {
            Logger.info(`Changing screen to ${value}`);
            navigate(constructNewPathname(selectedPark, value, pathname));
        }
    };

    return (
        <Container>
            <Left>
                <MediaMatcher minWidth="tablet">
                    <LogoContainer>
                        <Icon type="powerboard" height={16} />
                        <Logo src={RWELogo} alt="RWE Logo" style={{ verticalAlign: 'middle' }} />
                    </LogoContainer>
                </MediaMatcher>
                <ParkSelect />
                <MediaMatcher minWidth="tablet">
                    <ScreenSelect />
                </MediaMatcher>
            </Left>
            <Right>
                {isWebSocketEnabled && (
                    <React.Fragment key="1">
                        <MediaMatcher minWidth="medium">
                            <LightningRiskChart />
                        </MediaMatcher>
                        <SystemStatusBtn />
                    </React.Fragment>
                )}

                <MediaMatcher minWidth="phone">
                    <ClockContainer>
                        <Clock />
                    </ClockContainer>
                </MediaMatcher>
                <HeaderMenu
                    adminUrl={adminUrl}
                    isOpen={menuVisible}
                    isWebSocketEnabled={isWebSocketEnabled}
                    changeHandler={changeHandler}
                    userDisplayName={userDisplayName}
                    region={region}
                    selectedPark={selectedPark}
                    selectedScreen={selectedScreen}
                />
            </Right>
        </Container>
    );
};
